import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function BrowseAllFiles() {
  return <section data-section-id="227873" id="featured-transformations" className="dark bg-background text-foreground relative overflow-hidden py-12 md:py-16 lg:py-20 border-b border-border">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(to_right,var(--color-primary)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-primary)_1px,transparent_1px)] bg-[size:32px_32px] opacity-[0.07]"></div>
      
      {}
      <div className="absolute inset-0 pointer-events-none bg-background [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black_100%)] opacity-80"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-start max-w-4xl">
          <Breadcrumb className="mb-6">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="#">Home</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Featured Transformations</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default tracking-tight text-foreground">
            Featured Transformations
          </h1>
          
          <p className="mt-4 text-muted-foreground text-lg max-w-2xl font-sans">
            Experience the evolution of residential exteriors. Discover how our precision-engineered siding, roofing, and deck solutions redefine architectural beauty and structural integrity.
          </p>
        </div>
      </div>
    </section>;
}